import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {Platform, ScrollView} from 'react-native';
import {isFullSwing, LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from '../../../constants';
import ProfileContent from './Tabs/Profile';
import AsyncStorage from "@react-native-async-storage/async-storage";
import {StoreContext} from "../../../components/StoreContextProvider";
import useIdleLogout from "../../../hooks/useIdleLogout";
import MainStyle from "../../../../MainStyle";
import {User} from "../../../../generated/smg_service_pb";
import {useIsFocused, useNavigation, useRoute} from "@react-navigation/native";
import Wallet from "./Tabs/Wallet";
import Withdraw from "../../../components/Withdraw";
import AccountNavBar from "../../../components/AccountNavBar";
import moment from 'moment';
import {useSafeAreaInsets} from "react-native-safe-area-context";
import BottomNavigation from '../../../components/BottomNavigation';
import NewHeader from "../../../components/NewHeader";
import Div from "../../../lib/Div";
import P from "../../../lib/P";
import FSHeader from "../../../components/FSHeader";

const Account = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const Context = useContext(StoreContext);
  const {session, user, cancelModalConfig} = Context;
  const navigation: any = useNavigation();
  const route = useRoute();
  const insets = useSafeAreaInsets();
  // const confirmEmailDialogWasShown = useRef(false);
  const isFocused = useIsFocused();
  const titles: Record<number, string> = {0: 'Profile', 1: 'Deposit', 2: 'Withdrawal'};

  useEffect(() => {
    if (!user || !isFocused) return;
    let time: any;

    time = setTimeout(() => {
      Context.getUser().then();
    }, 1000 * 15);

    return () => {
      clearTimeout(time);
    };
  }, [user, isFocused]);

  useIdleLogout({onLogout: () => Context.setLoadingOverlay(false)});

  useLayoutEffect(() => {
    if (!session || !user) {
      Context.setLoadingOverlay(true);

      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') {
              window.open(LANDING_PAGE_URL, '_self');
            }
            Context.setLoadingOverlay(false);
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);
              console.log('user', curUser);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          Context.setLoadingOverlay(false);
          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            });
          }
        }
      })();

    } else {
      console.log('user', user);
    }
  }, []);

  useLayoutEffect(() => {
    const params: any = route.params;
    if (params) setCurrentTab(+params.step);
  }, [route.params]);

  return (
    <Div flex={1} pt={insets.top} position="relative">
      <ScrollView contentContainerStyle={MainStyle.min_h_full}>
        {isFullSwing ? (
          <FSHeader px={20} title={currentTab === 0 ? 'My Profile' : 'Wallet'} hideGameLogo/>
        ) : (
          <NewHeader pb={11}/>
        )}

        {!isFullSwing && (
          <Div px={21} mb={26}>
            <P fs={30} fw="500" lh={24}>{titles[currentTab]}</P>
          </Div>
        )}

        <AccountNavBar
          tabIndex={currentTab}
          onChange={(step) => navigation.navigate({name: 'account', params: {step}})}
        />

        {currentTab === 0 && user && <ProfileContent/>}

        {currentTab === 1 && user && <Wallet/>}

        {currentTab === 2 && user && (
          <Withdraw changeTab={(step) => navigation.navigate({name: 'account', params: {step}})}/>
        )}
      </ScrollView>

      {!isFullSwing && (
        <Div alignItems="center" maxW={1125} mx="auto" w="100%">
          <BottomNavigation page="account"/>
        </Div>
      )}
    </Div>
  );
};

export default Account;
